export default __webpack_public_path__ + "assets/models/fc254c8510021357738f4790ebcb9cff.gltf";